import { useMemo } from "react";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import type { WorkbookFilter } from "../../../../../../api/types/workbookRuns.types";
import { pluralize } from "@entrilia/shared/utilities/stringHelper";
import { getReportIdFromWorkbookFilterParameterId } from "@entrilia/shared/components/reporting/workbook/workbookFiltersHelper";

interface Props {
  filter: WorkbookFilter;
}

const WorkbookFilterItemLabelLinkedCounter = ({ filter }: Props) => {
  const linkedReportsNumber = useMemo(
    () => new Set(filter.linkedFilters.map((lf) => getReportIdFromWorkbookFilterParameterId(lf.id))).size,
    [filter.linkedFilters]
  );

  if (linkedReportsNumber === 0) {
    return null;
  }

  return (
    <TypographyTooltipEllipsis
      text={`Is used in ${linkedReportsNumber} ${pluralize("report", linkedReportsNumber)}`}
      typographyProps={{ color: "textSecondary", variant: "caption" }}
      tooltipProps={{ disableInteractive: true }}
    />
  );
};

export default WorkbookFilterItemLabelLinkedCounter;
